<template>
  <div class="fill-height">
    <div class="grid">
      <div class="border pa-5 d-flex flex-wrap">
        <div class="date-picker mt-n1">
          <label class="f14" style="margin-bottom: 5px">
            {{ localStorage.translations.pages.finance['period-table']['term'] }}
          </label>
          <v-menu
            ref="menu1"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details="auto"
                v-model="dateRangeText.data"
                v-bind="attrs"
                readonly
                validate-on-blur
                prepend-inner-icon="today"
                :placeholder="localStorage.translations.pages.common['text']['not_selected']"
                v-on="on"
                clearable
                @click:clear.stop="clearData()"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="$cookies.get('languageSelect').key"
              v-model="filter.dates"
              range
              no-title
              show-week
              first-day-of-week="1"
              :max="new Date().toISOString().slice(0, 10)"
              @change="getData(true)"
              class="temp"
            />
          </v-menu>
        </div>
        <BaseInput
          :key="key + 'p'"
          :label="localStorage.translations.pages['planning_orders'].table['proekt']"
          type="autocomplete"
          v-model="filter.checked.projects"
          :items="Object.values(filter.projects)"
          item-text="text"
          item-value="id"
          placeholder="—"
          multiple
          minimize
          small-chips
          :disabled="!Object.values(filter.projects).length"
          max-width="500px"
        />
        <BaseInput
          :key="key + 'e'"
          :label="localStorage.translations.pages.finance['period-table'].employee"
          type="autocomplete"
          v-model="filter.checked.employees"
          :items="Object.values(filter.employees)"
          item-text="text"
          item-value="id"
          placeholder="—"
          multiple
          minimize
          small-chips
          :disabled="!Object.values(filter.employees).length"
          max-width="500px"
        />
        <div class="ml-auto mt-5">
          <BaseButton
            :text="localStorage.translations.pages.common.buttons['clear']"
            @click="clearFilter"
            reverse
            height="30"
            :disabled="!filter.compare.projects.length && !filter.compare.employees.length"
          />
          <BaseButton
            :text="localStorage.translations.pages.common.buttons['primenit']"
            @click="getData(false)"
            height="30"
            class="ml-4"
            :disabled="!changed"
          />
        </div>
      </div>
      <template v-if="employeeSalaryManual.employees && Object.keys(employeeSalaryManual.employees).length > 0">
        <div>
          <div
            v-for="(employee, e) in employeeSalaryManual.employees"
            :key="'employee' + e"
            class="horizontalScroll"
          >
            <FinanceSalarySliceShowEmployee
              :data="employee"
              :id="e"
              :period="period"
              :check-edit-access="checkEditAccess"
              :on-update="onUpdate"
              :ref="'employee' + e"
              :collection="collection"
              :responsible-show="responsibleShow"
            />
          </div>
          <FinanceSalarySliceShowTable v-if="responsibleShow" total-responsible class="horizontalScroll">
            <div slot="title" class="pb-5 subtitle">
              {{ localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main }}
            </div>
            <FinanceSalarySliceShowTableHeader total-responsible />
            <FinanceSalarySliceShowTableTotal
              total-responsible
              v-for="(resp, r) in responsible"
              :key="r + '_responsible'"
              :responsible="resp"
            />
          </FinanceSalarySliceShowTable>
        </div>
        <div class="fixedBtn">
          <FinanceSalarySliceShowPdf
            :key="key"
            :period="period"
            :employees="employees"
            :disabled="changedData"
            :responsible="responsible"
            :responsible-show-total="responsibleShow"
          />
        </div>
      </template>
      <Plug v-else class="mt-10" />
    </div>
  </div>
</template>

<script>
import Plug from '../../../components/Plug'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseInput from 'components/base/BaseInput'
import FinanceSalarySliceShowEmployee from 'components/finance/salary/FinanceSalarySliceShowEmployee'
import FinanceSalarySliceShowPdf from 'components/finance/salary/show/FinanceSalarySliceShowPdf'
import FinanceSalarySliceShowTableTotal from 'components/finance/salary/show/FinanceSalarySliceShowTableTotal.vue'
import FinanceSalarySliceShowTableHeader from 'components/finance/salary/show/FinanceSalarySliceShowTableHeader.vue'
import FinanceSalarySliceShowTable from 'components/finance/salary/show/FinanceSalarySliceShowTable.vue'

export default {
  name: 'salaryManual',
  components: {
    FinanceSalarySliceShowTable,
    FinanceSalarySliceShowTableHeader,
    FinanceSalarySliceShowTableTotal,
    FinanceSalarySliceShowPdf,
    FinanceSalarySliceShowEmployee,
    BaseInput,
    Plug,
  },
  data: () => ({
    key: 0,
    menu: false,
    filter: {
      employees: {},
      projects: {},
      dates: [],
      checked: {
        employees: [],
        projects: [],
      },
      compare: {
        employees: [],
        projects: [],
      },
    },
  }),
  computed: {
    ...mapGetters('employeeSalaryManual', ['employeeSalaryManual']),
    dateStartFormatted() {
      return this.$formatDate(this.filter.start_date)
    },
    dateRangeText() {
      let dates = [...this.filter.dates]
      if (dates[0]) dates[0] = this.$formatDate(dates[0])
      if (dates[1]) dates[1] = this.$formatDate(dates[1])
      return { data: dates.join(' - ') }
    },
    collection() {
      let result = {
        current: { employees: {} },
        previous: { employees: {} },
      }
      let name = 'current'
      for (let e in this.employeeSalaryManual.employees) {
        let projects = this.employeeSalaryManual.employees[e].projects
        for (let p in projects) {
          let arr = ['work_types', 'extras']
          for (let a in arr) {
            let type = arr[a]
            if (projects[p][type]) {
              let works = projects[p][type]
              for (let w in works) {
                let days = works[w].days
                for (let d in days) {
                  name = d < this.filter.dates[0] ? 'previous' : 'current'
                  if (!result[name].employees[e]) result[name].employees[e] = { projects: {} }
                  if (!result[name].employees[e].projects[p])
                    result[name].employees[e].projects[p] = { name: projects[p].name }
                  if (!result[name].employees[e].projects[p][type])
                    result[name].employees[e].projects[p][type] = {}
                  if (!result[name].employees[e].projects[p][type][w]) {
                    result[name].employees[e].projects[p][type][w] = {
                      is_hourly: works[w].is_hourly,
                      measure: works[w].measure,
                      name: works[w].name,
                      salary: works[w].salary,
                    }
                    result[name].employees[e].projects[p][type][w].days = {}
                  }
                  if (!result[name].employees[e].projects[p][type][w].days[d])
                    result[name].employees[e].projects[p][type][w].days[d] = days[d]
                }
              }
            }
          }
        }
      }
      return result
    },
    period() {
      let temp = this.filter.dates
      let s = temp[0] ? temp[0].split('-') : []
      let e = temp[1] ? temp[1].split('-') : []
      return {
        term: s[2] + '.' + s[1] + '.' + s[0] + ' - ' + e[2] + '.' + e[1] + '.' + e[0],
      }
    },
    employees() {
      let result = []
      for (let i in this.employeeSalaryManual.employees) {
        if (this.$refs['employee' + i] && this.$refs['employee' + i][0]) {
          result.push(this.$refs['employee' + i][0].employee)
        }
      }
      return result
    },
    responsible() {
      let result = []
      for (let p in this.employeeSalaryManual.projects) {
        result.push({
          id: p,
          name: this.employeeSalaryManual.projects[p].name,
          responsible: this?.employeeSalaryManual?.projects[p]?.responsible ? Object.values(this.employeeSalaryManual.projects[p].responsible) : [],
          responsibleShow: this.employeeSalaryManual ? Object.keys(this.employeeSalaryManual.projects[p].responsible).length > 0 : false
        })
      }
      return result
    },
    responsibleShow() {
      let result = false
      for (let r in this.responsible) {
        if (this.responsible[r].responsibleShow)
          result = true
      }
      return result
    },
    checkEditAccess() {
      return this.$userCheckAccess({ abilities: 'edit_salary' })
    },
    changedData() {
      let result = [false]
      for (let e in this.employeeSalaryManual.employees)
        if (this.$refs['employee' + e] && this.$refs['employee' + e][0]) {
          let temp = this.$refs['employee' + e][0].changedData
          result = result.concat(Object.values(temp).map((d) => d.changedData))
        }
      return !result.every((e) => {
        return !e
      })
    },
    changed() {
      if (this.filter.compare.employees.length !== this.filter.checked.employees.length) return true
      if (this.filter.compare.projects.length !== this.filter.checked.projects.length) return true
      for (let i in this.filter.compare.employees)
        if (!this.filter.compare.employees.includes(this.filter.checked.employees[i])) return true
      for (let i in this.filter.compare.projects)
        if (!this.filter.compare.projects.includes(this.filter.checked.projects[i])) return true
      return false
    },
  },
  watch: {
    'filter.dates'() {
      if (
        this.filter.dates[0] &&
        this.filter.dates[1] &&
        this.filter.dates[0] > this.filter.dates[1]
      ) {
        this.filter.dates = [this.filter.dates[1], this.filter.dates[0]]
      }
    },
  },
  beforeDestroy() {
    this.setEmployeeSalaryManual({})
  },
  methods: {
    ...mapActions('employeeSalaryManual', [
      'onEmployeeSalaryManual',
      'onEmployeeSalaryManualClear',
    ]),
    ...mapActions('workClientProjectsPeriodReportUpdate', [
      'onWorkClientProjectsPeriodReportUpdate',
    ]),
    ...mapMutations('employeeSalaryManual', ['setEmployeeSalaryManual']),

    async getData(clear) {
      await this.onEmployeeSalaryManual({
        start: this.filter.dates[this.filter.dates[0] > this.filter.dates[1] ? 1 : 0],
        end: this.filter.dates[this.filter.dates[0] > this.filter.dates[1] ? 0 : 1],
        project: clear ? '' : this.filter.checked.projects,
        user: clear ? '' : this.filter.checked.employees,
      }).then((res) => {
        this.filter.compare.employees = Object.assign([], this.filter.checked.employees)
        this.filter.compare.projects = Object.assign([], this.filter.checked.projects)
        for (let i in res.data.employees)
          if (!this.filter.employees[i])
            this.filter.employees[i] = {
              id: i,
              text: res.data.employees[i]['first_name'] + ' ' + res.data.employees[i]['last_name'],
            }
        for (let i in res.data.projects)
          if (!this.filter.projects[i])
            this.filter.projects[i] = {
              id: i,
              text: res.data.projects[i].name,
            }
        this.key++
      })
    },

    async onUpdate(data, switchValue, extra, responsible) {
      if (data && data.length > 0) {
        this.loadingAnimationFullPage = true
        await this.onWorkClientProjectsPeriodReportUpdate({
          id: this.$route.params.report_id,
          data: responsible ? data.map(i => i.id) : data,
          paid: true,
          responsible: responsible,
          extra: extra,
        }).then(() => {
          this.getData(false)
        })
      }
    },

    clearFilter() {
      this.filter.checked.projects = []
      this.filter.checked.employees = []
      this.getData(true)
    },

    getPaidCheckbox(projects) {
      let all_paid = []
      let arr = ['work_types', 'extras']
      for (let p in projects)
        for (let r in arr) {
          let field = arr[r]
          for (const workKey in projects[p][field]) {
            const currentWork = projects[p][field][workKey]
            for (const dayKey in currentWork.days)
              if (currentWork.days[dayKey].reports) {
                let paid = currentWork.days[dayKey].reports.map((data) => data['paid_report'])
                all_paid = all_paid.concat(paid)
              }
          }
        }
      return all_paid.every((cur) => {
        return Number(cur) > 0
      })
        ? true
        : all_paid.every((cur) => {
            return Number(cur) === 0
          })
        ? false
        : null
    },

    changeData(projects, clear) {
      let data = {
        work_types: [],
        extras: [],
      }
      let arr = ['work_types', 'extras']
      for (let p in projects) {
        for (let r in arr) {
          let field = arr[r]
          for (const workKey in projects[p][field]) {
            const currentWork = projects[p][field][workKey]
            for (const dayKey in currentWork.days)
              if (currentWork.days[dayKey].reports)
                for (let r in currentWork.days[dayKey].reports) {
                  let temp = {}
                  temp.id = currentWork.days[dayKey].reports[r].id
                  let paid = clear
                    ? 0
                    : currentWork.days[dayKey].reports[r]['paid_report'] ||
                      currentWork.days[dayKey].reports[r]['approved_report']
                  projects[p][field][workKey].is_hourly === 1 || field === 'extras'
                    ? (temp['paid_hours'] = paid)
                    : (temp['paid_size'] = paid)
                  temp['paid_notes'] = currentWork.days[dayKey].reports[r]['paid_notes']
                  data[field].push(temp)
                }
          }
        }
      }
      this.onUpdate(data['work_types'], clear, false)
      this.onUpdate(data['extras'], clear, true)
    },

    clearData() {
      this.onEmployeeSalaryManualClear()
      this.data = {
        dates: [],
        project: [],
        user: [],
      }
    },
  },
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-row-gap: 30px;
}

.flex-wrap {
  column-gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    column-gap: 12px;
  }
}

.horizontalScroll {
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    overflow-x: scroll;
    max-width: 93vw;
  }
}

.subtitle {
  color: #277faf;
  font-weight: bolder;
}

.border {
  border: 1px solid #bdbdbd;
  border-radius: 10px;
}

.date-picker {
  label {
    color: #52525F;
    line-height: 16px;
  }

  :deep() .v-input.v-text-field .v-input__slot {
    min-height: 30px !important;
  }

  .v-input {
    border-radius: 10px !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  :deep() .v-input__append-inner {
    margin-top: 4px !important;
    margin-right: 2px !important;
  }

  :deep() input {
    padding: 4px 0 2px !important;
  }
}

:deep() .subtitle {
  color: #277faf;
  font-weight: bolder;
}
.temp {
  :deep() .v-input__slot {
    width: max-content !important;
  }
}
</style>